import { atom } from 'recoil';

import { iaRa } from 'lib/helpers/utility';
import { sessionPersistEffect } from 'lib/helpers/sessionPersistedAtom';

const PROGRESS_STORAGE_KEY = 'myriad:export-progress';

// Bounded: a dismissed id only has to outlive its own job's remaining ticks.
const MAX_DISMISSED = 50;

const sanitize = (value) => {
  const jobs = value?.jobs || {};
  const trimmed = {};

  Object.keys(jobs).forEach((id) => {
    const job = jobs[id];
    if (!job || !job.exportJobId) return;

    trimmed[id] = {
      exportJobId: job.exportJobId,
      status: job.status,
      type: job.type,
      fileName: job.fileName,
      error: job.error,
      stale: job.stale,
      staleSince: job.staleSince
    };
  });

  return {
    jobs: trimmed,
    dismissed: iaRa(value?.dismissed)
      .filter((id) => id != null)
      .slice(-MAX_DISMISSED)
  };
};

export const exportProgressState = atom({
  key: 'exportProgressState',
  default: { jobs: {}, dismissed: [] },
  effects: [sessionPersistEffect({ storageKey: PROGRESS_STORAGE_KEY, sanitize })]
});
